import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

const Spacer = ({ blok, className }) => (
  <SbEditable content={blok}>
    <div className={`spacer ${blok.size ? blok.size : className}`}></div>
  </SbEditable>
)

Spacer.defaultProps = {
  className: "",
}

Spacer.propTypes = {
  blok: PropTypes.shape({
    size: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
}

export default Spacer
